import { api } from "../../services/NetworkBase";

export async function GetVlpReports(reportType) {
  try {
    let response = await api.get(`vlp/report-settings/reports/${reportType}`).json();
    return response;
  } catch (error) {
    throw error;
  }
}

export async function GetVlpReport(reportId) {
  try {
    let response = await api.get(`vlp/report-settings/${reportId}`).json();
    return response;
  } catch (error) {
    throw error;
  }
}

export async function DeleteVlpReport(reportId) {
  try {
    let response = await api.delete(`vlp/report-settings/${reportId}`).json();
    return response;
  } catch (error) {
    throw error;
  }
}

export async function SaveVlpReport(report) {
  try {
    let response = await api
      .post(`vlp/report-settings`, {
        json: report,
      })
      .json();
    return response;
  } catch (error) {
    throw error;
  }
}

export async function UpdateVlpReport(report) {
  try {
    let response = await api
      .put(`vlp/report-settings`, {
        json: report,
      })
      .json();
    return response;
  } catch (error) {
    throw error;
  }
}
